"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _env = require("../utils/env");

function _addUserInformationToRequestBody(requestBody, userInformation) {
  var propertiesToAdd = Object.keys(userInformation).reduce(function (prev, key) {
    if (userInformation[key]) {
      prev.push(key);
    }

    return prev;
  }, []); // Only include user information property if password exists (omitts for auth'd existing users)

  if (propertiesToAdd.length && propertiesToAdd.indexOf('password') !== -1) {
    requestBody.userInformation = propertiesToAdd.reduce(function (userInfoObj, key) {
      userInfoObj[key] = userInformation[key];
      return userInfoObj;
    }, {});
  }

  return requestBody;
}

var _default = {
  submitProviderSignupForm: function submitProviderSignupForm(providerSignup) {
    var plainObjData = {
      domain: providerSignup.get('website'),
      email: providerSignup.get('contactEmail'),
      shouldCreateSidekickUser: true,
      trialType: 'PARTNER'
    };

    var requestBody = _addUserInformationToRequestBody(plainObjData, {
      firstName: providerSignup.get('firstName'),
      lastName: providerSignup.get('lastName'),
      password: providerSignup.get('password')
    });

    var urlRoot = "https://app.hubspot" + ((0, _env.isProd)() ? '' : 'qa') + ".com";
    return _noAuthApiClient.default.post(urlRoot + "/signup/v1/trial/signup", {
      data: requestBody
    });
  }
};
exports.default = _default;
module.exports = exports.default;